.atm_mk_h2mmj6{position:relative;}
.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_vy_f6fqlb{width:18px;}
.atm_e2_f6fqlb{height:18px;}
.atm_jb_f6fqlb{min-width:18px;}
.atm_j6_f6fqlb{min-height:18px;}
.atm_vy_1tcgj5g{width:24px;}
.atm_e2_1tcgj5g{height:24px;}
.atm_jb_1tcgj5g{min-width:24px;}
.atm_j6_1tcgj5g{min-height:24px;}
.atm_vy_1vi7ecw{width:32px;}
.atm_e2_1vi7ecw{height:32px;}
.atm_jb_1vi7ecw{min-width:32px;}
.atm_j6_1vi7ecw{min-height:32px;}
.atm_vy_1ylpe5n{width:40px;}
.atm_e2_1ylpe5n{height:40px;}
.atm_jb_1ylpe5n{min-width:40px;}
.atm_j6_1ylpe5n{min-height:40px;}
.atm_vy_fyhuej{width:48px;}
.atm_e2_fyhuej{height:48px;}
.atm_jb_fyhuej{min-width:48px;}
.atm_j6_fyhuej{min-height:48px;}
.atm_vy_1fwpi09{width:64px;}
.atm_e2_1fwpi09{height:64px;}
.atm_jb_1fwpi09{min-width:64px;}
.atm_j6_1fwpi09{min-height:64px;}
.atm_vy_u29brm{width:80px;}
.atm_e2_u29brm{height:80px;}
.atm_jb_u29brm{min-width:80px;}
.atm_j6_u29brm{min-height:80px;}
.atm_c8_1jrhifa.atm_c8_1jrhifa{font-size:var(--fabric-number-n-2-px);}
.atm_c8_8oey0.atm_c8_8oey0{font-size:var(--fabric-number-n-2-5-px);}
.atm_c8_4bemk8.atm_c8_4bemk8{font-size:var(--fabric-font-size-xs);}
.atm_c8_v7fmpo.atm_c8_v7fmpo{font-size:var(--fabric-font-size-sm);}
.atm_c8_18b5chc.atm_c8_18b5chc{font-size:var(--fabric-font-size-md);}
.atm_c8_st4a4i.atm_c8_st4a4i{font-size:var(--fabric-font-size-h3);}
.atm_vy_1osqo2v{width:100%;}
.atm_e2_1osqo2v{height:100%;}
.atm_jb_idpfg4{min-width:0;}
.atm_j6_idpfg4{min-height:0;}
.atm_uc_144ry0i{transition:transform 0.2s ease-in-out;}
.atm_kd_jqi6yc{outline:2px solid var(--fabric-color-neutral-00);}
.atm_5j_1ssbidh{border-radius:50%;}
.atm_fxc23i_lv2r3y:hover{transform:scale(1.15);}
.atm_1ukwr7f_tlke0l:hover{cursor:pointer;}
.atm_13isjya_zo7u8:hover{z-index:10;}
.atm_1ukwr7f_73adwj:hover{cursor:default;}
.atm_mk_stnw88{position:absolute;}
.atm_vy_1ssbidh{width:50%;}
.atm_e2_1ssbidh{height:50%;}
.atm_jb_1ssbidh{min-width:50%;}
.atm_j6_1ssbidh{min-height:50%;}
.atm_vy_16tw3kv{width:52%;}
.atm_e2_16tw3kv{height:52%;}
.atm_jb_16tw3kv{min-width:52%;}
.atm_j6_16tw3kv{min-height:52%;}
.atm_vy_mlf1tl{width:55%;}
.atm_e2_mlf1tl{height:55%;}
.atm_jb_mlf1tl{min-width:55%;}
.atm_j6_mlf1tl{min-height:55%;}
.atm_vy_hv4lt8{width:65%;}
.atm_e2_hv4lt8{height:65%;}
.atm_jb_hv4lt8{min-width:65%;}
.atm_j6_hv4lt8{min-height:65%;}
.atm_tk_o2qy27{top:7.5%;}
.atm_fq_idpfg4{left:0;}
.atm_wq_kb7nvz{z-index:1;}
.atm_6i_o2qy27{bottom:7.5%;}
.atm_n3_idpfg4{right:0;}
.atm_wq_cs5v99{z-index:2;}
.atm_tk_idpfg4{top:0;}
.atm_fq_blwoaz{left:22.5%;}
.atm_6i_1x1l4y3{bottom:25%;}
.atm_fq_1wqof6l{left:-5%;}
.atm_n3_1wqof6l{right:-5%;}
.atm_wq_11wpgbn{z-index:3;}
.atm_fq_ka7hnc{left:15%;}
.atm_wq_egatvm{z-index:4;}
.atm_6i_9by0np{bottom:10%;}
.atm_n3_ka7hnc{right:15%;}
.atm_fq_16gx6hh{left:5%;}
.atm_n3_16gx6hh{right:5%;}
.atm_6i_idpfg4{bottom:0;}
.atm_2d_bkcxml.atm_2d_bkcxml{background-color:var(--fabric-color-neutral-30);}
.atm_7l_1v3jjb1{color:var(--fabric-color-neutral-00);}
.atm_3f_glywfm{border:none;}
.atm_cs_bxxw8r.atm_cs_bxxw8r{font-weight:var(--fabric-font-weight-bold);}
.atm_g3_kb7nvz.atm_g3_kb7nvz{line-height:1;}
.atm_9j_tlke0l{cursor:pointer;}
.atm_17yrrpa_zxmnng:focus-visible{outline:2px solid var(--fabric-color-focus-ring);}
.atm_6zeuib_yh40bf:focus-visible{outline-offset:2px;}
.atm_9j_73adwj{cursor:default;}
.atm_vy_1kpv4x5{width:56%;}
.atm_e2_1kpv4x5{height:56%;}
.atm_tk_1ssbidh{top:50%;}
.atm_fq_1ssbidh{left:50%;}
.atm_tr_1ooetej{transform:translate(-50%, -50%);}
.atm_wq_qfx8er{z-index:5;}
.atm_70_yd2a2b{box-shadow:0 0 0 2px var(--fabric-color-neutral-00);}
